import { deprecated } from '../../../constants/texts';

export default class Route extends React.PureComponent {
  componentDidMount() {
    console.warn('eDoCat Router Route -- ', deprecated);
  }

  render() {
    return React.createElement(this.props.component, this.props.props);
  }
}
